import { Pipe, PipeTransform, inject } from '@angular/core';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { ApplePayService } from '@df/module-apple-pay/apple-pay.service';
import find from 'lodash-es/find';
import includes from 'lodash-es/includes';

@Pipe({
    name: 'applePayFilter',
    standalone: true
})
export class ApplePayFilterPipe implements PipeTransform {
    private applePayService = inject(ApplePayService);

    private lastMethods: Checkout.IPaymentMethod[] = [];

    transform(methods: Checkout.IPaymentMethod[], applePayCodes: string[], version?: number): Checkout.IPaymentMethod[] {
        if (
            !methods ||
            !methods.length ||
            !applePayCodes ||
            !applePayCodes.length ||
            (this.applePayService.isAvailable && (!version || this.applePayService.isSupportedVersion(version)))
        ) {
            return methods;
        }

        const newMethods = methods.filter(method => typeof method.code !== 'string' || !includes(applePayCodes, method.code));

        if (newMethods.length !== this.lastMethods.length || find(newMethods, (method, index) => method !== this.lastMethods[index])) {
            this.lastMethods = newMethods;
        }
        return this.lastMethods;
    }
}
